import * as React from 'react';
import { createRoot } from 'react-dom/client';

import DesignSystemPage from '@/pages/DesignSystem';
import { renderWithUiRoot, resolveReactMountContainer } from '@/js/wisemetering/ui/render_with_ui_root';

WiseMetering.Views.DesignSystem = Backbone.Marionette.View.extend({
    id: 'react-container',
    className: 'tailwind-container',

    onShow: function() {
        const container = resolveReactMountContainer(this);
        const root = createRoot(container);

        renderWithUiRoot(root, container, <DesignSystemPage />);
    }
});
